import React, { useEffect, useState } from 'react';
import { Switch } from 'src/components/ui/switch';
import { clsx } from 'clsx';

export const SwitchKBComponent = ({
  isFetching,
  disabled = false,
  defaultChecked,
  onCheckedChange = (_value?: any) => {},
}: {
  isFetching?: any;
  disabled?: boolean;
  defaultChecked?: any;
  onCheckedChange?: (value?: any) => void;
}) => {
  const [checkedState, setCheckedState] = useState(defaultChecked);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    setCheckedState(defaultChecked);
  }, [defaultChecked]);

  const handleChange = (val) => {
    setCheckedState(val);
    onCheckedChange(val);
    setIsChanged(true);
  };

  useEffect(() => {
    if (!isFetching) {
      setIsChanged(false);
    }
  }, [isFetching]);

  return (
    <Switch
      disabled={disabled}
      checked={checkedState}
      defaultChecked={defaultChecked}
      className={clsx(isChanged && 'blur-sm animate-pulse pointer-events-none')}
      onCheckedChange={handleChange}
    />
  );
};
